// The fetch of the browser from before any library wraps it. src/index.tsx imports this module first.

/**
 * The fetch of the browser, without the LogRocket wrapper. LogRocket resolves each
 * response only after it reads a clone of the body to the end, so a response that
 * streams, such as text/event-stream, never resolves. Use it for streamed responses only.
 */
export const nativeFetch: typeof fetch = globalThis.fetch.bind(globalThis);
